export default function Wallet() {
  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, minHeight: '60vh' }}>
      <div style={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12 }}>
        <div style={{ fontSize: 52, marginBottom: 8, color: '#C19A6B' }}>◈</div>
        <div style={{ fontFamily: "'Bebas Neue', sans-serif", fontSize: 28, color: '#1A1814', letterSpacing: 2 }}>WALLET</div>
        <div style={{ fontSize: 14, color: '#7A7570', lineHeight: 1.7, maxWidth: 280 }}>Deposit funds, track escrow, and withdraw winnings. Powered by Stripe. Coming soon.</div>
      </div>
    </div>
  )
}
